export { default } from './TimelineDot';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/esm/TimelineDot/index.js
// module id = 897
// module chunks = 2